import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareIosLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M8.11 6.646a1 1 0 0 0 1.415 0L11 5.172v7.07a1 1 0 1 0 2 0v-7.07l1.475 1.474a1 1 0 0 0 1.414-1.414L12.707 2.05a1 1 0 0 0-1.414 0L8.11 5.232a1 1 0 0 0 0 1.414'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M8.5 10.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H15v-2h.5a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3H9v2z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareIosLine)
export default ForwardRef
